import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { x } from '@xstyled/styled-components';
import { Section, ContainerVertical } from '@aftersale-next/ui';
import { ChannelSelector } from '../components/channel/channel-selector';
import ChannelConfirmationMessage from '../components/channel/channel-confirmation-message';
export function ChannelSelectionPage() {
  return /*#__PURE__*/_jsx(ContainerVertical, {
    custom: true,
    children: /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsxs(x.div, {
        display: "flex",
        flexDirection: "column",
        spaceY: "4",
        children: [/*#__PURE__*/_jsx(ChannelConfirmationMessage, {}), /*#__PURE__*/_jsx(ChannelSelector, {})]
      })
    })
  });
}